import { SectionLabel } from '@/components/marketing/v2/SectionLabel';
import { DemoVideoCard } from './DemoVideoCard';

type VideoSpec = {
  title: string;
  description: string;
  duration: string;
  youtubeId?: string;
};

// Les vidéos ne sont pas encore tournées. Aucun ID YouTube inventé — dès
// qu'une vidéo est publiée, renseigner son `youtubeId` ici pour activer
// l'embed (voir DemoVideoCard).
const VIDEOS: ReadonlyArray<VideoSpec> = [
  {
    title: 'Configurer une page commerciale',
    description: 'Configurer une page commerciale pour la vente.',
    duration: '3 min',
    youtubeId: 'ii95c4DhoRs',
  },
  {
    title: 'Stock produit',
    description: 'Ajouter une quantité en stock.',
    duration: '30 s',
    youtubeId: 'PJTjY1iurQg',
  },
  {
    title: 'Connecter un point de vente (POS)',
    description: 'Mettre en œuvre une connexion à un point de vente (POS).',
    duration: '47 s',
    youtubeId: '76hC8HEvnWI',
  },
  {
    title: 'Édition du prix pendant la vente',
    description: "Éditer le prix de l'article pendant la vente.",
    duration: '15 s',
    youtubeId: 'Kp9a-EqWtPY',
  },
  {
    title: 'Ventes troc',
    description: 'Enregistrer une vente par troc.',
    duration: '37 s',
    youtubeId: 'WmJYaHnvo9Y',
  },
  {
    title: 'Bar / Activation',
    description: 'Activer le module bar.',
    duration: '38 s',
    youtubeId: 'FPp7y8aynQI',
  },
  {
    title: 'Troc / Activation',
    description: 'Activer le module troc.',
    duration: '16 s',
    youtubeId: '0Cs__4xVjuQ',
  },
  {
    title: 'Retour / Activation',
    description: 'Activer le module retour.',
    duration: '19 s',
    youtubeId: 'nJeeYULBYIY',
  },
  {
    title: 'Page commerciale / Activation',
    description: 'Activer une page commerciale.',
    duration: '25 s',
    youtubeId: 'p4R9G5JDoIs',
  },
  {
    title: 'Partenaire / Activation',
    description: 'Activer le module partenaire.',
    duration: '34 s',
    youtubeId: 'U8ovTAFxWKo',
  },
  {
    title: "Création d'un partenaire",
    description: 'Ajouter un nouveau partenaire dans sa boutique.',
    duration: '28 s',
    youtubeId: 'ePUBWDwdatQ',
  },
  {
    title: "IMEI lors de la vente",
    description: "Saisie et association de l'IMEI au produit lors de la transaction de vente.",
    duration: '20 s',
    youtubeId: 'OUqd-buBgSI',
  },
  {
    title: "Enregistrer le règlement d'une échéance.",
    description: "Permet d'enregistrer le paiement d'une échéance client.",
    duration: '16 s',
    youtubeId: 'pw94xutVi7A',
  },
  {
    title: "Enregistrer une commande en caisse",
    description: "Saisissez et enregistrez une commande en caisse avant sa validation ou son paiement.",
    duration: '37 s',
    youtubeId: '4sdVONVjIZc',
  },
  {
    title: "Enregistrer une sortie vers un partenaire",
    description: "Enregistrez une sortie de stock à destination d'un partenaire tout en assurant son suivi.",
    duration: '37 s',
    youtubeId: 'cVUJefS50OA',
  },
  {
    title: "Enregistrer une vente effectuée par un partenaire",
    description: "Enregistrez une vente réalisée par un partenaire afin de mettre à jour les stocks et les opérations associées.",
    duration: '29 s',
    youtubeId: '6MyZ9xJRivc',
  },
  {
    title: "Synchronisation forcée des données",
    description: "Déclenchez une synchronisation immédiate des données avec le serveur.",
    duration: '10 s',
    youtubeId: 'xOFxlY9-VtE',
  },
  {
    title: "Retour produit",
    description: "Enregistrement d'un retour produit.",
    duration: '36 s',
    youtubeId: '13EQwUYpCYg',
  },
];

export default function DemoVideosSectionV2() {
  return (
    <section id="videos" className="border-y-2 border-charcoal-800 bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel>Démo vidéo</SectionLabel>
        <h2 className="mt-3 max-w-2xl font-marketing-display text-[clamp(30px,4.4vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-charcoal-800">
          Module par module, <span className="underline-lime">à ton rythme.</span>
        </h2>
        <p className="mt-4 max-w-xl font-marketing-body text-[17px] text-charcoal-600">
          Découvre les fonctionnalités essentielles de Velko en vidéo, puis réserve une démo live
          plus bas pour approfondir les sujets qui t'intéressent.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {VIDEOS.map((video) => (
            <DemoVideoCard key={video.title} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
}
